// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3aa93817","239":"dc3cfd71","455":"d5469bc0"}[chunkId] + ".chunk.js";
};